import { initPublicHeader } from './header';

function syncServiceExpandedState(serviceItem) {
    const container = serviceItem.querySelector('.sub-services-container');
    const btn = serviceItem.querySelector('.expand-toggle-btn');

    if (container && container.classList.contains('show')) {
        serviceItem.classList.add('expanded');
        if (btn) {
            btn.setAttribute('aria-expanded', 'true');
            btn.classList.remove('collapsed');
        }
    } else {
        serviceItem.classList.remove('expanded');
        if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.add('collapsed');
        }
    }
}

function initServiceCollapseStates() {
    document.querySelectorAll('.service-item').forEach(syncServiceExpandedState);

    document.addEventListener('shown.bs.collapse', function (event) {
        const serviceItem = event.target.closest('.service-item');
        if (!serviceItem) return;

        if (window.innerWidth <= 991) {
            const offset = serviceItem.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({
                top: offset,
                behavior: 'smooth',
            });
        }

        serviceItem.classList.add('expanded');
        const btn = serviceItem.querySelector('.expand-toggle-btn');
        if (btn) {
            btn.setAttribute('aria-expanded', 'true');
            btn.classList.remove('collapsed');
        }
    });

    document.addEventListener('hidden.bs.collapse', function (event) {
        const serviceItem = event.target.closest('.service-item');
        if (!serviceItem) return;

        serviceItem.classList.remove('expanded');
        const btn = serviceItem.querySelector('.expand-toggle-btn');
        if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.add('collapsed');
        }
    });
}

function initBookButtons() {
    const productList = document.getElementById('product-list');
    const reservationsUrl = productList?.dataset.reservationsUrl;

    if (!reservationsUrl) {
        return;
    }

    document.querySelectorAll('.book-subservice-btn').forEach(button => {
        button.addEventListener('click', function () {
            window.location.href = reservationsUrl;
        });
    });
}

function initParallaxImages() {
    window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset;
        const parallaxContainers = document.querySelectorAll('.parallax-img');

        parallaxContainers.forEach(container => {
            const img = container.querySelector('img');
            if (!img) return;

            const height = container.offsetHeight;
            const maxOffset = height * 0.2;
            const multiplier = 0.3;
            let offset = scrollTop * multiplier;

            if (offset > maxOffset) offset = maxOffset;

            img.style.top = `-${offset}px`;
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initPublicHeader();
    initServiceCollapseStates();
    initBookButtons();
    initParallaxImages();
});
